import React from "react";

const UserTable = ({ userData, onDeletePuja }) => {
  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped">
        <thead className="thead-dark">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Image</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {userData && userData.length > 0 ? (
            userData.map((puja, index) => (
              <tr key={puja.puja_category_id}>
                <td>{index + 1}</td>
                <td>{puja.puja_category_title}</td>
                <td>
                  <img
                    src={puja.image_url}
                    alt={puja.puja_category_title}
                    style={{ width: "50px", height: "50px" }}
                  />
                </td>
                <td>
                  {puja.is_active === 1 ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-danger">Inactive</span>
                  )}
                </td>
                <td>{new Date(puja.created_at).toLocaleDateString()}</td>
                <td>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => onDeletePuja(puja.puja_category_id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
